<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="flex flex-align-center gap-sm">
          <app-back-button [ariaLabel]="'settings.back' | translate" />
          <span>{{ 'settings.logging.title' | translate }}</span>
        </div>
      </app-card-title>
    </app-card-header>
    <app-card-content>
      <app-log-controls />
    </app-card-content>
  </app-card>
</div>